import React from 'react';

type Props = {
  color?: string;
  onClick?: () => void;
} & typeof defaultProps;

const defaultProps = {
  color: '#606060',
  onClick: () => { },
};

const CloseIconDrawer = function CloseIconDrawer({ color, onClick }: Props) {
  return (


    <svg className="closeSvgIcon" width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
      <circle opacity="0.543816" cx="16.5" cy="16.5" r="16.5" fill={color} fill-opacity="0.620013" />
      <path d="M10.8194 22.4526L22.4525 10.8196" stroke="white" stroke-width="3" stroke-linecap="square" />
      <path d="M10.8193 10.8196L22.4524 22.4526" stroke="white" stroke-width="3" stroke-linecap="square" />
    </svg>


  );
};

CloseIconDrawer.defaultProps = defaultProps;

export default CloseIconDrawer;
